import styled from 'styled-components';

export const InputError = styled.div`
    color: #fff;
    border: 1px soild #dc3545;
    background-color:#dc3545;
    border-radius:0.25rem;
    margin-top:0.5rem;
`
